import { TFormField } from "../../@types/common";
import { useAuth } from "../../components/context/AuthContext";
import { API_PASSWORD_RESET } from "../../constants/apis";
import { TEXT } from "../../constants/constants";
import { TSet } from "../common/useSet";

export const usePasswordResetForm = () => {
  const { user } = useAuth();
  const email = user?.email;

  const fields: TFormField[] = [
    {
      field: "email",
      type: TEXT,
      props: {
        readOnly: email,
        helperText: "We shall send a reset link to this email address",
      },
    },
  ];

  const onSubmit = ({ payload }: any): TSet => {
    return { api: API_PASSWORD_RESET, params: payload };
  };
  return { fields, onSubmit, defaultValues: { email } };
};
